import RoundedButton from 'components/RoundedButton';
import Subheading from 'components/Subheading';
import { extendClassName } from 'utils/common';

interface CongratsSectionProps {
  additionalClassName: string;
  revealInProgress: unknown;
  prizeWins: unknown[];
  materialPrizeWins: unknown[];
  tokensWon: number;
}

export const CongratsSection = ({
  additionalClassName,
  revealInProgress,
  prizeWins,
  materialPrizeWins,
  tokensWon,
}: CongratsSectionProps) => {
  if (revealInProgress || prizeWins.length === 0) {
    return null;
  }

  return (
    <div
      className={extendClassName(
        'congratsSection fullWidth flexCentered',
        additionalClassName
      )}
    >
      <Subheading>Congrats!</Subheading>

      {materialPrizeWins.length > 0 && (
        <>
          <p>
            You won{' '}
            <strong>
              {materialPrizeWins.length} prize
              {materialPrizeWins.length > 1 ? 's' : ''}
            </strong>{' '}
            in this draw
          </p>
          <RoundedButton href="/account/my-prizes">Claim now</RoundedButton>
        </>
      )}

      {materialPrizeWins.length === 0 && tokensWon > 0 && (
        <>
          <p>
            You won{' '}
            <strong>
              {tokensWon} token{tokensWon > 1 ? 's' : ''}
            </strong>{' '}
            in this draw
          </p>
          <RoundedButton href="/token-town">Redeem now</RoundedButton>
        </>
      )}

      <style jsx>
        {`
          .congratsSection {
            margin: 1.5em 0;
          }

          :global(.congratsSection .roundedButton) {
            margin-top: 1em;
          }
        `}
      </style>
    </div>
  );
};
